import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-wilmar',
  templateUrl: './link-wilmar.component.html',
  styleUrls: ['./link-wilmar.component.scss'],
})
export class LinkWilmarComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;
  @Output() next = new EventEmitter();
  public busy = true;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('RETAILEXPRESS_CHANNEL');
  public win;

  public configurationSaved: boolean = false;
  public companyID: string = '';
  public clientID: string = null;
  public url: string = null;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.busy = false;
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        CompanyID: this.partner.PartnerID,
        ClientID: this.partner.PartnerID,
        //Username: this.username,
        //Password: this.password,
        POSID: 16,
        //StoreURL: this.url,
        //ClientID: this.clientID
      })
      .subscribe((x) => {
        if (this.modal !== undefined) this.modal.dismiss('Cross click');
        else this.next.emit();
      });
  }

  done() {
    this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }
}
